import { render, staticRenderFns } from "./TableAllDataC.vue?vue&type=template&id=65ebd770&"
import script from "./TableAllDataC.vue?vue&type=script&lang=js&"
export * from "./TableAllDataC.vue?vue&type=script&lang=js&"
import style0 from "./TableAllDataC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports